'use client';
import MinusIcon from '../icons/MinusIcon';
import PlusIcon from '../icons/PlusIcon';
import useHandleCart from '@/hooks/cart/useHandleCart';

const QtyControlBtns = ({ quantity, item_id, fromPopup = false }) => {
  const { loading, handleUpdateCart } = useHandleCart();

  return (
    <div className='flex items-center justify-center gap-2.5'>
      <button
        onClick={() => handleUpdateCart(true, item_id, quantity)}
        disabled={quantity <= 1 || loading === 'subtracting'}
        className={`flex size-6 cursor-pointer items-center justify-center rounded-sm border border-[#E4E4F9] ${fromPopup ? '' : 'md:size-8 md:rounded-md'} disabled:cursor-not-allowed disabled:bg-zinc-100 disabled:opacity-75`}
      >
        {loading === 'subtracting' ? (
          <span className='size-4 animate-spin rounded-full border-t border-r border-black' />
        ) : (
          <MinusIcon />
        )}
      </button>

      <div
        className={`flex size-6 cursor-pointer items-center justify-center rounded-sm border border-[#E4E4F9] ${fromPopup ? '' : 'md:size-8 md:rounded-md'} text-center`}
      >
        {quantity}
      </div>

      <button
        onClick={() => handleUpdateCart(false, item_id, quantity)}
        disabled={loading === 'adding'}
        className={`flex size-6 cursor-pointer items-center justify-center rounded-sm border border-[#E4E4F9] ${fromPopup ? '' : 'md:size-8 md:rounded-md'} disabled:cursor-not-allowed disabled:bg-zinc-100 disabled:opacity-75`}
      >
        {loading === 'adding' ? (
          <span className='size-4 animate-spin rounded-full border-t border-r border-black' />
        ) : (
          <PlusIcon />
        )}
      </button>
    </div>
  );
};

export default QtyControlBtns;
